import type { FunctionComponent } from 'react';
import {
  getDropship,
  getItemsCount,
  getPending,
  getSaleTypes,
  getShipped,
} from '../../utils/orders';
import CollapsibleBar from '../CollapsibleBar';
import MobileProductList from '../MobileProductList';
import OrderSummary from '../OrderSummary';
import * as styles from './styles.module.scss';

type Order = {
  billingDate: string;
  shipments: Record<string, unknown>[];
  orderTotalInCents: number;
  shippingAddress: Record<string, unknown>;
};

type OrderDetailsProps = {
  order: Order;
  onClickBack: () => void;
  trackShipment: (order: Order, trackingNumber: string) => void;
};

const OrderDetails: FunctionComponent<OrderDetailsProps> = ({
  order,
  onClickBack,
  trackShipment,
}) => {
  const { billingDate, shipments, orderTotalInCents, shippingAddress } = order;
  const saleType = getSaleTypes(shipments);
  const shipped = getShipped(shipments);
  const pending = getPending(shipments);
  const dropship = getDropship(shipments);
  const handleTrackShipment = (trackingNumber) => trackShipment(order, trackingNumber);

  return (
    <div className={styles.orderDetails} data-testid="order-details-container">
      <button
        type="button"
        className={styles.backButton}
        onClick={onClickBack}
        data-testid="order-details-back-button"
      >
        <i className="far fa-chevron-left" />
        Back to Orders
      </button>
      <h1>{saleType}</h1>
      <div className={styles.detailsContainer}>
        <CollapsibleBar title="Order Details" headerClickable>
          <OrderSummary
            billingDate={billingDate}
            items={getItemsCount(shipments)}
            orderTotal={orderTotalInCents / 100}
            shippingAddress={shippingAddress}
          />
        </CollapsibleBar>
      </div>
      <div className={styles.shipments}>
        <h2 className={styles.title}>Shipments</h2>
        <MobileProductList
          shipped={shipped}
          pending={pending}
          dropship={dropship}
          trackShipment={handleTrackShipment}
        />
      </div>
    </div>
  );
};

export default OrderDetails;
